import AddOnGroupServices from "../services/AddOnGroupServices";
export const FETCH_ADD_ON_GROUPS_SUCCESS = "FETCH_ADD_ON_GROUPS_SUCCESS";

export const GET_ADD_ON_GROUPS_SUCCESS = "GET_ADD_ON_GROUPS_SUCCESS";
export const GET_ADD_ON_GROUPS_FAILED = "GET_ADD_ON_GROUPS_FAILED";

const fetchAddOnGroupsSuccess = (addOnGroups) => ({
  type: FETCH_ADD_ON_GROUPS_SUCCESS,
  payload: addOnGroups,
});

// fetch brands
export const fetchAddOnGroups = (addOnGroups) => {
  return (dispatch) => {
    dispatch(fetchAddOnGroupsSuccess(addOnGroups));
  };
};
//////////////////

export const getAddOnGroups = () => {
  return (dispatch) => {
    AddOnGroupServices.getAllAddOnsByGroup()
      .then((res) => {
        dispatch({
          type: GET_ADD_ON_GROUPS_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_ADD_ON_GROUPS_FAILED,
          payload: err,
        });
      });
  };
};
